import {
  selectPortfolioName,
  selectUserEmail,
  selectUserRole,
  selectUsername,
  selectUserPicture,
} from '@/features/auth/authSelector';
import { getAvatarColor, getInitials } from '@/utils/avatar';
import { SwapOutlined } from '@ant-design/icons';
import { Avatar, Breadcrumb, Button, Dropdown, Layout, Menu, Space, Tag, Tooltip } from 'antd';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const { Header } = Layout;

const MainHeader = ({
  breadcrumbItems = [],
  userMenuItems = [],
  showSelectPortfolio = false,
  onSelectPortfolio,
}) => {
  const portfolioName = useSelector(selectPortfolioName);
  const username = useSelector(selectUsername);
  const email = useSelector(selectUserEmail);
  const role = useSelector(selectUserRole);
  const picture = useSelector(selectUserPicture);

  const avatarColor = useMemo(() => getAvatarColor(username), [username]);
  const initials = useMemo(() => getInitials(username), [username]);

  const dropdownRender = () => (
    <div className="user-dropdown">
      <div className="user-dropdown-header">

        {picture ? (
          <Avatar src={picture} />
        ) : (
          <Avatar size={70} style={{ backgroundColor: avatarColor, fontWeight: 500, fontSize: 30 }}>
            {initials}
          </Avatar>
        )}
        <div className="user-dropdown-info">
          <div className="user-dropdown-name">{username || 'User'}</div>
          <div className="user-dropdown-email">{email || ''}</div>
          {role && (
            <Tag color="blue" className="user-dropdown-role">
              {role === "User" ? "Standard" : role}
            </Tag>
          )}
        </div>
      </div>
      <Menu items={userMenuItems} className="user-dropdown-menu" />
    </div>
  );

  return (
    <Header className="top-header">
      <div className="header-left">
        <Breadcrumb items={breadcrumbItems} />
      </div>
      <Space className="header-right" size={16}>
        {showSelectPortfolio && (
          <Tooltip title="Switch Portfolio">
            <Button
              type="text"
              icon={<SwapOutlined />}
              onClick={onSelectPortfolio}
              className="switch-portfolio-btn"
            />
          </Tooltip>
        )}
        <Dropdown popupRender={dropdownRender} placement="bottomRight" trigger={['click']}>
          <Space className="user-profile" size={12}>
            <div className="user-meta">
              <div className="user-portfolio">{portfolioName || 'No Portfolio'}</div>
              <div className="user-name">{username || 'User'}</div>
            </div>
            {picture ? (
              <Avatar src={picture} />
            ) : (
              <Avatar size={38} style={{ backgroundColor: avatarColor, fontWeight: 500 }}>
                {initials}
              </Avatar>
            )}
          </Space>
        </Dropdown>
      </Space>
    </Header>
  );
};

export default MainHeader;
